import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import * as styles from './CheckboxButton.style';
export const CheckboxButton = _ref => {
  let {
    id,
    value,
    dataRef,
    disabled,
    required,
    onChange,
    text,
    name,
    checked,
    error,
    valid,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledLabel, {
    "data-ref": `${dataRef}-label`,
    htmlFor: id,
    $isDisabled: disabled,
    $isChecked: checked,
    $error: error,
    $valid: valid,
    $_css: styles.label
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    name: name,
    value: value,
    disabled: disabled,
    required: required,
    onChange: onChange,
    checked: checked,
    "aria-checked": checked,
    "data-ref": `${dataRef}-input`
  }, rest, {
    type: "checkbox"
  })), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement(_StyledSpan, {
    "data-ref": `${dataRef}-text`,
    $_css2: styles.text
  }, text));
};
CheckboxButton.defaultProps = {
  dataRef: 'checkbox-button'
};
export default CheckboxButton;
var _StyledLabel = _styled("label").withConfig({
  displayName: "CheckboxButton___StyledLabel",
  componentId: "sc-1t5czm0-0"
})(["", ""], p => p.$_css);
var _StyledSpan = _styled("span").withConfig({
  displayName: "CheckboxButton___StyledSpan",
  componentId: "sc-1t5czm0-1"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=CheckboxButton.js.map